import React, { useCallback, useEffect, useState } from "react"
import { FaChevronLeft } from "react-icons/fa"
import { useNavigate, useParams } from "react-router-dom"
import { toast, ToastContainer } from "react-toastify"
import Table, { TableAction } from "../../components/common/Table"
import { request } from "../../services/request"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../store/store"
import { changeloaderState } from "../../store/loaderSlice"
import { LocationsDetail, LocationDetailResponse, LocationsFloor, LocationsSensor } from "../../services/authinterface"
import { ViewIcon } from "../../icons/webSvg"
import PrimaryButton from "../../components/subComponents/PrimaryButton"

// const dashboardData = {
//     location: {
//         name: "Lincoln High School",
//         status: "Active",
//         owner: "Lincoln HS",
//         contact_email: "school@lincolnhs.edu",
//         address: "1400 Elm St, Springfield",
//         city: "Springfield",
//         state: "IL",
//         zip: "62701",
//         created: "2025-07-15"
//     },
//     overview: {
//         devices: { total: 14, active: 12, offline: 2 },
//         recent_events: [
//             { date: "2025-08-15", time: "10:42", description: "Device OK" },
//             { date: "2025-08-15", time: "09:15", description: "Location Self-check passed" }
//         ],
//         key_contacts: [
//             {
//                 name: "John Smith",
//                 title: "Facilities Manager",
//                 email: "jsmith@lincolnhs.edu",
//                 phone: "(555) 123-9876"
//             }
//         ]
//     },
//     floorplans: [
//         {
//             name: "Main Building – 1st Fl",
//             level_type: "Level 1",
//             uploaded: "2025-07-16 14:22 EDT",
//             devices: 6
//         },
//         {
//             name: "Main Building – 2nd Fl",
//             level_type: "Level 2",
//             uploaded: "2025-07-16 14:25 EDT",
//             devices: 5
//         },
//         {
//             name: "Gymnasium",
//             level_type: "Annex",
//             uploaded: "2025-07-20 09:03 EDT",
//             devices: 3
//         }
//     ],
//     devices: [
//         {
//             device_id: "DEV-21F7-9A33",
//             status: "Active",
//             last_contact: "2025-08-15 10:42",
//             model: "G3-SBS-R2D",
//             uptime: "6d 3h"
//         },
//         {
//             device_id: "DEV-77B2-004C",
//             status: "Offline",
//             last_contact: "2025-08-14 18:05",
//             model: "G3-SBS-R2D",
//             uptime: null
//         }
//         // ... more devices as needed
//     ]
// }

const Icon: any = FaChevronLeft

const LocationDetail: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>()
    const param = useParams()
    const navigate = useNavigate()
    const [locationDetail, setLocationDetail] = useState<LocationsDetail[]>([])
    const [selectedSensors, setSelectedSensors] = useState<any>([])
    const [selectedFloorPlans, setSelectedFloorPlans] = useState<any>([])
    const [shouldResetCheckbox, setShouldResetCheckbox] = useState<boolean>(false)

    console.log({ selectedSensors }, { selectedFloorPlans })

    const fetchLocationDetails = useCallback(async () => {
        try {
            dispatch(changeloaderState(true))
            const response = await request<LocationDetailResponse>({
                url: `/adminCommon/getLocationDetails/${param.id}`,
                method: "GET",
            })
            if (response.data) {
                setLocationDetail(response.data)
            } else {
                toast.error("Failed to fetch Location Detail: " + response.message)
            }
        } catch (error) {
            toast.error("Something went wrong")
        } finally {
            dispatch(changeloaderState(false))
        }
    }, [dispatch, param])

    useEffect(() => {
        fetchLocationDetails()
    }, [fetchLocationDetails])

    console.log({ locationDetail })

    const getBack = () => {
        navigate(-1)
    }

    const floorPlanAction: TableAction[] = [
        {
            label: "",
            onClick: (row: LocationsFloor) => {
                navigate(`/location/sensors/${row.id}`)
            },
            className: "table-btn-2",
            icon: (
                <ViewIcon />
            ),
        },
    ]

    const deviceAction: TableAction[] = [
        {
            label: "",
            onClick: (row: LocationsSensor) => {
                navigate(`/location/device-details/${row.id}`)
            },
            className: "table-btn-2",
            icon: (
                <ViewIcon />
            ),
        },
    ]

    // Floorplan Table Columns
    const floorplanColumns = [
        { name: "Floorplan Name", value: (fp: LocationsFloor) => fp?.name, id: "name" },
        // { name: "Level/Type", value: (fp: LocationsFloor) => fp.level_type, id: "level_type" },
        {
            name: "Uploaded", value: (fp: LocationsFloor) => (
                <span className="location-details-font ms-1">
                    {new Date(locationDetail[0]?.createdAt).toLocaleString("en-US", {
                        timeZone: "America/New_York",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false, // 24-hour format
                    }).replace(",", "")} EDT
                </span>

            ), id: "uploaded"
        },
        { name: "Alerted Sensors", value: (fp: LocationsFloor) => fp?.activesensors || 0, id: "devices" },
        { name: "Devices", value: (fp: LocationsFloor) => fp?.totalsensors || "-", id: "devices" },
        {
            name: "",
            value: () => "",
            id: "action",
            render: () => (
                <button className="btn btn-secondary btn-sm" onClick={() => {/* view logic */ }}>View</button>
            )
        }
    ];

    // Devices Table Columns
    const devicesColumns = [
        { name: "Device ID", value: (dev: LocationsSensor) => dev?.detail || "-", id: "device_id" },
        {
            name: "Status", value: (dev: LocationsSensor) => (
                <span className="d-flex align-items-center">
                    <span
                        className={`me-2 rounded-circle ${dev.status !== "0" ? "bg-success" : "bg-danger"}`}
                        style={{ width: "10px", height: "10px", display: "inline-block" }}
                    ></span>
                    <span>{dev.status === "0" ? "Offline" : "Active"}</span>
                </span>

            ), id: "status"
        },
        {
            name: "Last Contact",
            value: (dev: LocationsSensor) =>
                dev?.testedAt ? new Date(dev?.testedAt).toLocaleString("en-CA", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false
                }).replace(",", "") : "-",  // remove comma after date
            id: "last_contact"
        },
        // { name: "Model", value: (dev: LocationsSensor) => dev.model, id: "model" },
        {
            name: "Uptime",
            value: (dev: LocationsSensor) => {
                if (!dev?.testedAt) return "-";

                const lastContact = new Date(dev?.testedAt);
                const now = new Date();
                let diffMs = now.getTime() - lastContact.getTime();

                if (diffMs < 0) return "—"; // future dates guard

                const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                diffMs -= days * (1000 * 60 * 60 * 24);

                const hours = Math.floor(diffMs / (1000 * 60 * 60));
                diffMs -= hours * (1000 * 60 * 60);

                const minutes = Math.floor(diffMs / (1000 * 60));

                if (days > 0) {
                    return `${days}d ${hours}h`;
                } else if (hours > 0) {
                    return `${hours}h ${minutes}m`;
                } else {
                    return `${minutes}m`;
                }
            },
            id: "uptime"
        },
        {
            name: "",
            value: () => "",
            id: "action",
            render: () => (
                <button className="btn btn-secondary btn-sm" onClick={() => {/* view logic */ }}>View</button>
            )
        }
    ];

    const handleAlert = async () => {
        if(selectedSensors.length > 0){
            const sensorsparams = selectedSensors?.map((item: any) => item?.id)
            try {
                const response = await request({
                    url: `/adminCommon/sensorClear`,
                    method: "POST",
                    headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" },
                    data: sensorsparams,
                })
                if (response.data) {
                    if(selectedFloorPlans.length === 0){
                        toast.success(response.message)
                    }
                } else {
                    toast.error(response.message)
                }
            } catch (error: any) {
                toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
            }
        }
        if(selectedFloorPlans.length > 0){
            const floorplanparams = selectedFloorPlans?.map((item: any) => item?.id)
            try {
                const response = await request({
                    url: `/adminCommon/clearFloorplanAlert`,
                    method: "POST",
                    headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" },
                    data: floorplanparams,
                })
                if (response.data) {
                    toast.success(response.message)
                } else {
                    toast.error(response.message)
                }
            } catch (error: any) {
                toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
            }
        }
        setShouldResetCheckbox(true)
        setSelectedFloorPlans([])
        setSelectedSensors([])
        fetchLocationDetails()
    }


    return (
        <section className='dashboard-section dashboard-item'>
            <ToastContainer position='top-right' autoClose={2000} theme='light' />
            <div className='container'>
                <div className='row'>
                    <div className='col-12 mb-3'>
                        <div className='d-flex gap-2 align-items-center customer-detail-line'>
                            <button onClick={getBack} className='d-flex align-items-center p-0 mr-2'>
                                <Icon size={20} />
                            </button>
                            <div className='dashboard-table-title-section'>
                                <h2 className="mb-0">Location Details</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        <div className="rounded p-3 shadow-sm">
                            <div className="d-flex flex-wrap align-items-center">
                                <div className="me-4">
                                    <h6 className="d-inline mb-0">Location:</h6>
                                    <span className="location-details-font ms-1">{locationDetail[0]?.name}</span>
                                </div>

                                <div className="me-4">
                                    <h6 className="d-inline mb-0">Status:</h6>
                                    <span
                                        className={`ms-2 rounded-circle ${locationDetail[0]?.status === "1" ? "bg-success" : "bg-danger"}`}
                                        style={{ width: "10px", height: "11px", display: "inline-block" }}
                                    ></span>
                                    <span className="location-details-font ms-1">
                                        {locationDetail[0]?.status === "1" ? "Active" : "Offline"}
                                    </span>
                                </div>

                                <div className="me-4">
                                    <h6 className="d-inline mb-0">Owner:</h6>
                                    <span className="location-details-font ms-1">{!locationDetail[0]?.locationUserAccount?.first_name && !locationDetail[0]?.locationUserAccount?.last_name
                                        ? "-"
                                        : (locationDetail[0]?.locationUserAccount?.first_name ? locationDetail[0]?.locationUserAccount?.first_name : "") +
                                        " " +
                                        (locationDetail[0]?.locationUserAccount?.last_name ? locationDetail[0]?.locationUserAccount?.last_name : "")} </span>
                                    {/* (<span className="location-details-font">{location.contact_email}</span>) */}
                                </div>
                            </div>

                            <div className="d-flex flex-wrap mt-2">
                                <div className="me-4">
                                    <h6 className="d-inline mb-0">Address:</h6>
                                    <span className="location-details-font ms-1">{locationDetail[0]?.address}</span>
                                </div>
                                {/* <div className="me-4">
                                    <h6 className="d-inline mb-0">City:</h6>
                                    <span className="location-details-font ms-1">{location.city}</span>
                                </div>
                                <div className="me-4">
                                    <h6 className="d-inline mb-0">State:</h6>
                                    <span className="location-details-font ms-1">{location.state}</span>
                                </div>
                                <div className="me-4">
                                    <h6 className="d-inline mb-0">Zip:</h6>
                                    <span className="location-details-font ms-1">{location.zip}</span>
                                </div> */}
                                <div className="me-4">
                                    <h6 className="d-inline mb-0">Created:</h6>
                                    <span className="location-details-font ms-1">
                                        {new Date(locationDetail[0]?.createdAt).toLocaleDateString("en-CA")}
                                    </span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        <div className="rounded p-3 shadow-sm">
                            <h5 className="mb-3">Overview</h5>
                            <div className="row">

                                {/* Devices */}
                                <div className="col-md-4 p-2">
                                    <h6>Devices</h6>
                                    <div className="d-flex gap-2 location-details-font">
                                        <div>Total: {locationDetail[0]?.locationsSensor?.length || 0}</div>
                                        <div>
                                            (<span>
                                                Active: {locationDetail[0]?.locationsSensor?.filter((s: LocationsSensor) => s.status !== "0").length || 0}
                                            </span>,{" "}
                                            <span>
                                                Offline: {locationDetail[0]?.locationsSensor?.filter((s: LocationsSensor) => s.status === "0").length || 0}
                                            </span>)
                                        </div>
                                    </div>

                                </div>

                                {/* <div className="col-md-4 p-2">
                                    <h6>Recent Events</h6>
                                    {dashboardData.overview.recent_events.map((event, idx) => (
                                        <div key={idx} className="location-details-font">
                                            {event.date} {event.time} &nbsp; &nbsp; {event.description}
                                        </div>
                                    ))}
                                </div>

                                <div className="col-md-4 p-2">
                                    <h6>Key Contacts</h6>
                                    {dashboardData.overview.key_contacts.map((contact, idx) => (
                                        <div key={idx} className="location-details-font">
                                            <div>{contact.name}, {contact.title}</div>
                                            <div>{contact.email} &nbsp; {contact.phone}</div>
                                        </div>
                                    ))}
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        <div className="rounded p-3 shadow-sm">
                            <h5>Floor Plans ({locationDetail[0]?.LocationsFloor?.length})</h5>
                            <Table
                                paginate={false}
                                page={1}
                                rowsPerPage={1000}
                                setPage={() => { }}
                                rowData={locationDetail[0]?.LocationsFloor || []}
                                action={floorPlanAction}
                                setRowsPerPage={() => { }}         // Add this
                                totalItems={locationDetail[0]?.LocationsFloor?.length || 0}
                                columns={floorplanColumns}
                                // Optional: Add pagination if needed
                                isSearch={false}
                                setSelected={setSelectedFloorPlans}
                                shouldResetCheckbox={shouldResetCheckbox}
                                setShouldResetCheckbox={setShouldResetCheckbox}
                            />
                        </div>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-12">
                        <div className="rounded p-3 shadow-sm">
                            <h5>Devices at this Location</h5>
                            <Table
                                paginate={false}
                                page={1}
                                rowsPerPage={1000}
                                setPage={() => { }}
                                action={deviceAction}
                                rowData={locationDetail[0]?.locationsSensor || []}
                                setRowsPerPage={() => { }}
                                totalItems={locationDetail[0]?.locationsSensor?.length || 0}
                                columns={devicesColumns}
                                isSearch={false}
                                setSelected={setSelectedSensors}
                                shouldResetCheckbox={shouldResetCheckbox}
                                setShouldResetCheckbox={setShouldResetCheckbox}
                            />
                        </div>
                    </div>
                </div>
                {(selectedSensors.length > 0 || selectedFloorPlans.length > 0) && <div>
                    <PrimaryButton
                        label={`Clear Alert${selectedSensors.length + selectedFloorPlans.length > 1 ? "(s)" : ""}`}
                        className='max-w-max-content m-0'
                        onClick={handleAlert}
                    />
                </div>}

            </div>
        </section>
    )
}

export default LocationDetail
